var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"slide-artwork"}},[_c('video',{ref:"video",attrs:{"muted":"","preload":"auto","poster":_vm.videoPoster,"playsinline":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.videoSource,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }